import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

import bosnia1 from '../images/bosnia1.jpeg';
import bosnia2 from '../images/bosnia2.jpeg';
import bosnia3 from '../images/bosnia3.jpeg';
import bosnia4 from '../images/bosnia4.jpeg';
import bosnia5 from '../images/bosnia5.jpeg';
import bosnia6 from '../images/bosnia6.jpeg';
import bosnia7 from '../images/bosnia7.jpeg';
import bosnia8 from '../images/bosnia8.jpeg';
import bosnia9 from '../images/bosnia9.jpeg';
import bosnia10 from '../images/bosnia10.jpeg';
import bosnia11 from '../images/bosnia11.jpeg';
import bosnia12 from '../images/bosnia12.jpeg';
import bosnia13 from '../images/bosnia13.jpeg';
import bosnia14 from '../images/bosnia14.jpeg';
import bosnia15 from '../images/bosnia15.jpeg';
import bosnia16 from '../images/bosnia16.jpeg';
import bosnia17 from '../images/bosnia17.jpeg';
import bosnia18 from '../images/bosnia18.jpeg';
import bosnia19 from '../images/bosnia19.jpeg';
import bosnia20 from '../images/bosnia20.jpeg';
import bosnia21 from '../images/bosnia21.jpeg';
import bosnia22 from '../images/bosnia22.jpeg';
import bosnia23 from '../images/bosnia23.jpeg';
import bosnia24 from '../images/bosnia24.jpeg';
import bosnia25 from '../images/bosnia25.jpeg';
import bosnia26 from '../images/bosnia26.jpeg';
import bosnia27 from '../images/bosnia27.jpeg';
import bosnia28 from '../images/bosnia28.jpeg';
import bosnia29 from '../images/bosnia29.jpeg';
import bosnia30 from '../images/bosnia30.jpeg';
import bosnia31 from '../images/bosnia31.jpeg';
import bosnia32 from '../images/bosnia32.jpeg';
import bosnia33 from '../images/bosnia33.jpeg';

function Bosnia() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images - bosnia1 through bosnia33
  const photos = [
    bosnia1, bosnia2, bosnia3, bosnia4, bosnia5, bosnia6, bosnia7, bosnia8, bosnia9, bosnia10,
    bosnia11, bosnia12, bosnia13, bosnia14, bosnia15, bosnia16, bosnia17, bosnia18, bosnia19, bosnia20,
    bosnia21, bosnia22, bosnia23, bosnia24, bosnia25, bosnia26, bosnia27, bosnia28, bosnia29, bosnia30,
    bosnia31, bosnia32, bosnia33
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇧🇦 Bosnia and Herzegovina 2025 🇧🇦</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Bosnia and Herzegovina ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Bosnia;